import { WORKSPACE_PLAN } from '@/entities/workspace/constants';
import { TALK_TO_SALES_LINK } from '@/features/setting/helpers/talk-to-sales';

export type CreatorSearchLimitActionKind = 'internal' | 'external';
export type CreatorSearchLimitActionButtonVariant = 'default' | 'outline';
export type CreatorSearchLimitVariant = 'upgrade' | 'sales';

export interface CreatorSearchLimitAction {
  kind: CreatorSearchLimitActionKind;
  label: string;
  href: string;
  buttonVariant: CreatorSearchLimitActionButtonVariant;
}

export interface CreatorSearchLimitNudgeViewModel {
  title: string;
  body: string;
  supportingBody: string;
  variant: CreatorSearchLimitVariant;
  action: CreatorSearchLimitAction;
}

function formatCount(count: number): string {
  return Math.max(count, 0).toLocaleString();
}

function getCreatorSearchLimitAction(
  plan: WORKSPACE_PLAN,
  workspaceId: string,
): CreatorSearchLimitAction {
  if (plan === WORKSPACE_PLAN.TRIAL || plan === WORKSPACE_PLAN.BASIC) {
    return {
      kind: 'internal',
      label: 'Upgrade to Enterprise',
      href: `/workspace/${workspaceId}/settings/plan`,
      buttonVariant: 'default',
    };
  }

  return {
    kind: 'external',
    label: 'Talk to sales',
    href: TALK_TO_SALES_LINK,
    buttonVariant: 'outline',
  };
}

export function getCreatorSearchLimitNudgeViewModel(
  plan: WORKSPACE_PLAN,
  workspaceId: string,
  searchResultLimit: number,
): CreatorSearchLimitNudgeViewModel {
  const action = getCreatorSearchLimitAction(plan, workspaceId);
  const variant = action.kind === 'internal' ? 'upgrade' : 'sales';
  const limitText = formatCount(searchResultLimit);

  return {
    title: 'Want to explore a broader creator pool?',
    body: `This workspace currently scans up to ${limitText} creators in each search.`,
    supportingBody:
      variant === 'upgrade'
        ? 'Upgrade to Enterprise to search across a wider creator pool in this workspace.'
        : "Talk to sales about expanding this workspace's search range.",
    variant,
    action,
  };
}
